export default __webpack_public_path__ + "static/b3-752cf01428a4da35fbd6003a66e3e337.jpg";